var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEcuador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0107C0 7.17424 7.1635 0.0107422 16 0.0107422C24.8365 0.0107422 32 7.17424 32 16.0107L16 17.4021L0 16.0107Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14062 24.0108C4.90719 28.793 10.0774 32.0108 15.9996 32.0108C21.9218 32.0108 27.0921 28.793 29.8586 24.0108L15.9996 22.9673L2.14062 24.0108Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.859 24.0107C31.2204 21.6574 32 18.9252 32 16.0107H0C0 18.9252 0.779625 21.6574 2.141 24.0107H29.859Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5759C19.0736 21.5759 21.5652 19.0843 21.5652 16.0107C21.5652 12.9372 19.0736 10.4456 16 10.4456C12.9264 10.4456 10.4348 12.9372 10.4348 16.0107C10.4348 19.0843 12.9264 21.5759 16 21.5759Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 19.489C14.0818 19.489 12.5215 17.9286 12.5215 16.0107V13.9238C12.5215 12.0059 14.0819 10.4456 15.9997 10.4456C17.9176 10.4456 19.478 12.0059 19.478 13.9238V16.0107C19.478 17.9287 17.9177 19.489 15.9997 19.489Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 7.66304H17.3913C17.3913 6.89467 16.7683 6.27173 15.9999 6.27173C15.2316 6.27173 14.6086 6.89467 14.6086 7.66304H10.4347C10.4347 8.43148 11.104 9.05435 11.8723 9.05435H11.826C11.826 9.82279 12.4489 10.4457 13.2173 10.4457C13.2173 11.2141 13.8402 11.837 14.6086 11.837H17.3913C18.1597 11.837 18.7826 11.2141 18.7826 10.4457C19.551 10.4457 20.1739 9.82279 20.1739 9.05435H20.1276C20.8959 9.05435 21.5652 8.43142 21.5652 7.66304Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEcuador);
export default __webpack_public_path__ + "static/media/flag_ecuador.f8685c866fffccc603624918ef7b635b.svg";
export { ForwardRef as ReactComponent };